export default __webpack_public_path__ + "static/map-c4afb400adcbdebdd9b1612fef32ad47.png";